import React from 'react';

const MapContainer = ({ mapContainer, lng, lat, zoom, loadingSpinning }) => {
  return (
    <div style={{ position: "relative" }}>
      <div className="map-container-sidebar">
        Longitude, Latitude: {lng}, {lat} | Zoom: {zoom}
      </div>
      <div
        id="loader"
        className="map-container-sidebar"
        style={{
          visibility: loadingSpinning ? "visible" : "hidden",
        }}
      ></div>
      <div ref={mapContainer} className="map-container"></div>
    </div>
  );
};

export default MapContainer;
